module.exports = __webpack_public_path__ + "static/media/hh.de261985.svg";